import React, { Fragment } from "react";
import { Row, Col, Table, Badge } from "reactstrap";

const Information = ({ data }) => {
  return (
    <Fragment>
      <Row className="mt-4">
        <Col sm="12">
          <Table>
            <tbody>
              <tr>
                <th>Client Company</th>
                <td className="text-right pr-5">
                  {data.Company?.client_company_name || "-"}
                </td>
              </tr>
              <tr>
                <th>Category</th>
                <td className="text-right pr-5">
                  {data.sales_category?.name || "-"}
                </td>
              </tr>
              <tr>
                <th>Product Name</th>
                <td className="text-right pr-5">{data.product_name || "-"}</td>
              </tr>
              {/* <tr>
                                <th>Type</th>
                                <td className="text-right pr-5">{data.product_type || '-'}</td>
                            </tr>
                            <tr>
                                <th>Online Link</th>
                                <td className="text-right pr-5">{data.online_link || '-'}</td>
                            </tr>
                            <tr>
                                <th>Pre-Owned EW</th>
                                <td className="text-right pr-5">{data.pre_owned_ew || '-'}</td>
                            </tr>
                            <tr>
                                <th>Within OEM</th>
                                <td className="text-right pr-5">{data.within_oem || '-'}</td>
                            </tr> */}
              <tr>
                <th>Status</th>
                <td className="text-right pr-5">
                  {/* {data.status || '-'} */}
                  <Badge
                    color={data.status === "Active" ? "success" : "danger"}
                  >
                    {!data.status
                      ? "-"
                      : data.status.toUpperCase() == "INACTIVE"
                      ? "Deactivate"
                      : data.status}
                  </Badge>
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Information;
